import React, { ComponentType } from 'react'

type TickerIconProps = {
  type: string
  noTicker?: boolean
}

export const TickerIcon: ComponentType<TickerIconProps> = ({ type, noTicker = false }) => {
  let icon, alt
  switch (type) {
    case 'StartPeriod':
      icon = 'icon_event_start'
      alt = 'Beginn'
      break
    case 'Goal':
      icon = 'icon_event_handball_goal'
      alt = 'Tor'
      break
    case 'Warning':
      icon = 'icon_event_start'
      alt = 'Warnung'
      break
    case 'Timeout':
      icon = 'icon_event_time'
      alt = 'Unterbrechung'
      break
    case 'SevenMeterGoal':
      icon = 'icon_event_handball_meter'
      alt = 'Siebenmeter'
      break
    case 'Parade':
      icon = 'icon_event_parade'
      alt = 'Parade'
      break
    case 'TwoMinutePenalty':
      icon = 'icon_event_icehockey_two'
      alt = 'Zwei Minuten Strafe'
      break
    case 'StopPeriod':
      icon = 'icon_event_end'
      alt = 'Ende'
      break

    case 'Red':
      icon = 'icon_event_red'
      alt = 'Rote Karte'
      break
    case 'Yellow':
      icon = 'icon_event_yellow'
      alt = 'Gelbe Karte'
      break
    case 'Blue':
      icon = 'icon_event_blue'
      alt = 'Blaue Karte'
      break
    case 'Card':
      icon = 'icon_event_card'
      alt = 'Karte'
      break

    default:
      icon = null
  }

  if (!icon) return null

  if (!noTicker) {
    return (
      <div className="tik3-flex-event-meta-state__icon tik3-event-item-icon">
        <img src={`/img/iconpack/${icon}.svg`} alt={alt}/>
      </div>)
  } else {
    return (
    <div className='w-5 md:w-7 h-5 md:h-7 inline-block'>
      <img src={`/img/iconpack/${icon}.svg`} alt={alt}/>
    </div>
    )
  }
}
